module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/pill-style3/pill-style3.component.scss
// module id = ./src/app/features/tabination/pill-style3/pill-style3.component.scss
// module chunks = main